module.exports = __webpack_public_path__ + "img/block-375.e6d2d21a.jpg";